/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { ProjectList } from 'src/app/common/fancy-firebase/services/factories';
import { Project } from '../models/Project';

export class ProjectsApi extends FancyActionableFirebase<Project, FancyAction, ProjectList> {
	constructor(public data: ProjectList) {
		super(data);
	}
}
